import Header from "../../Template/Header";
import { ColumnsType } from "antd/es/table";
import IsDataNull from "../../Template/IsDataNull";
import MergeRequestBrandProcessLogNavigationLink from "../MergeRequestBrandProcessLogComponent/MergeRequestBrandProcessLogNavigationLink";
import MergeRequestTabTableSecondaryBrandValue from "./MergeRequestTabTableSecondaryBrandValue";

const MergeRequestTabTableColumn: ColumnsType<any> = [
  {
    title: <Header data="Name" />,
    dataIndex: "name",
    sorter: true,
    width: 100,
    render: (data, record) => (
      <MergeRequestBrandProcessLogNavigationLink
        data={data}
        record={record}
        id={record.id}
      />
    ),
  },
  {
    title: <Header data={"Primary Brand"} />,
    dataIndex: "primaryBrandName",
    sorter: true,
    width: 100,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <Header data={"Secondary Brands"} />,
    dataIndex: "secondaryBrands",
    sorter: false,
    width: 300,
    render: (data) => <MergeRequestTabTableSecondaryBrandValue brands={data} />,
  },
  {
    title: <Header data={"Website"} />,
    dataIndex: "website",
    sorter: true,
    width: 150,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <Header data={"Created At"} />,
    dataIndex: "createdAt",
    sorter: true,
    width: 150,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <Header data={"Created By"} />,
    dataIndex: "createdBy",
    sorter: true,
    width: 150,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <Header data={"Status"} />,
    dataIndex: "status",
    sorter: true,
    width: 200,
    render: (data) => <IsDataNull data={data} />,
  },
];

export default MergeRequestTabTableColumn;
